/**
 * Galerie v obsahu (content blok „gallery") = Swiper carousel (free/auto),
 * stejně jako slider u referencí. Obrázky se zvětšují lightboxem (.blog-image).
 * Swiper je globál z vendor bundle.
 */
function initContentGalleries() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('.cb-gallery-swiper').forEach((el) => {
        // V obsahu může být galerií víc — navigace se hledá uvnitř obalu TÉTO instance.
        const host = el.parentElement;

        new Swiper(el, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            grabCursor: true,
            mousewheel: {
                forceToAxis: true, // jen vodorovné gesto
            },
            watchOverflow: true,
            navigation: {
                nextEl: host?.querySelector('.slider-nav--next') || null,
                prevEl: host?.querySelector('.slider-nav--prev') || null,
            },
            breakpoints: {
                820: { spaceBetween: 24 },
            },
        });
    });
}

document.addEventListener('DOMContentLoaded', initContentGalleries);
